import React, { useEffect } from "react"
import { Button, Col, Row } from "react-bootstrap"
import { FormikProvider, useFormik } from "formik"
import * as yup from "yup"
import { PopupQuestion } from "../../../../../component/atoms/Popup/index.jsx"
import { NoteView } from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"

export const ModalUnfreezeMitra = ({
  show = false,
  onClose = () => {},
  onSubmit = () => {}
}) => {
  const { t } = useTranslation()

  const validationSchema = yup.object({
    reason: yup.string().required(t("label_error_required", { label: t("label_reason") }))
  })

  const formik = useFormik({
    initialValues: {
      reason: ""
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values)
      handleClose()
    }
  })

  useEffect(() => {
    if (!show) {
      formik.resetForm()
    }
  }, [show])

  const handleClose = () => {
    formik.resetForm()
    onClose()
  }

  const renderBody = () => (
    <div>
      <div className="mb-3">
        <NoteView variant={"completed"} title={t("messages_alert_labeling_status_impact_mitra")} />
        <label>
          {t("input_change_mitra_status_reason")}
          <span className="text-danger ml-1" aria-hidden="true">*</span>
        </label>
        <textarea
          required={true}
          rows={4}
          className={`form-control ${
            formik.touched.reason && formik.errors.reason ? "is-invalid" : ""
          }`}
          name="reason"
          value={formik.values.reason}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder={t("placeholder_input_reason")}
        />
        {formik.touched.reason && formik.errors.reason && (
          <div className="invalid-feedback d-block">{formik.errors.reason}</div>
        )}
      </div>

      <Row className="justify-content-center mt-4">
        <Col>
          <Button
            className="font-weight-bold w-100"
            variant="outline-primary"
            block={true}
            onClick={handleClose}>
            {t("button_batal")}
          </Button>
        </Col>
        <Col>
          <Button
            className="font-weight-bold w-100"
            variant="primary"
            disabled={!formik.values.reason}
            block={true}
            onClick={() => formik.handleSubmit()}>
            {t("button_next")}
          </Button>
        </Col>
      </Row>
    </div>
  )

  return (
    <FormikProvider value={formik}>
      <PopupQuestion
        show={show}
        title={t("label_unfreeze").toUpperCase()}
        bodyCustom={renderBody()}
        isUseFooter={false}
        onCancel={handleClose}
        closeButton={false}
        centered={true}
      />
    </FormikProvider>
  )
}
